export const useProgrammaticUpsells = (): boolean => false;

export default useProgrammaticUpsells;
